<template>
  <div v-if="this.shoudlBuildReadOnlyAlert()">
    <emd-alert
      class="eu-mt_0 eu-no-mb eu-mt_5"
      variant="info"
      noClose
      :title="$t(this.buildText())"
      :autoclose="false"
      data-testid="emd-alert"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { EmdAlert } from 'emerald-vue/src/components'
import { isCheckoutCreateAllowed } from '@/action-permissions/checkout.permissions'

export default {
  name: 'ReadOnlyAlert',
  data () {
    return {
      showReadOnlyAlert: false
    }
  },
  components: {
    EmdAlert
  },
  computed: {
    ...mapGetters(['permissionIsEnabled'])

  },
  methods: {
    shoudlBuildReadOnlyAlert () {
      return this.showReadOnlyAlert
    },
    buildText () {
      if (this.showReadOnlyAlert) {
        return 'readOnlyAlert.readOnly'
      }
    }
  },
  mounted () {
    if (!isCheckoutCreateAllowed(this.permissionIsEnabled)) {
      this.showReadOnlyAlert = true
    }
  }
}
</script>
